<div class="new-set-dialog">
  <h2>Create New Item Set</h2>
  <form [formGroup]="newSetForm" (ngSubmit)="createSet()">
    
    <!-- Set Name Field -->
    <div class="field">
      <label for="setName">Set Name *</label>
      <input type="text" 
             id="setName"
             pInputText 
             formControlName="name"
             placeholder="Enter set name"
             [class.ng-invalid]="isFieldInvalid('name')"
             class="w-100">
      <small class="error-message" *ngIf="isFieldInvalid('name')">
        {{ getFieldError('name') }}
      </small>
    </div>

    <!-- Internal Name Field -->
    <div class="field">
      <label for="internalName">Internal Name *</label>
      <input type="text" 
             id="internalName"
             pInputText 
             formControlName="internalName"
             placeholder="Enter internal name"
             [class.ng-invalid]="isFieldInvalid('internalName')"
             class="w-100">
      <small class="error-message" *ngIf="isFieldInvalid('internalName')">
        {{ getFieldError('internalName') }}
      </small>
      <small class="field-help">
        Used for internal reference. Auto-generated from set name.
      </small>
    </div>

    <!-- Environment Selection -->
    <div class="field">
      <label for="environment">Environment(s) *</label>
      <p-multiSelect 
        [options]="environmentOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="env"
        placeholder="Select environments"
        [class.ng-invalid]="isFieldInvalid('env')"
        class="w-100">
      </p-multiSelect>
      <small class="error-message" *ngIf="isFieldInvalid('env')">
        {{ getFieldError('env') }}
      </small>
      <small class="field-help">
        Select which environments this set should be available in.
      </small>
    </div>

    <!-- Enabled Checkbox -->
    <div class="field checkbox-field">
      <p-checkbox formControlName="enabled" 
                  binary="true" 
                  inputId="enabledCheckbox">
      </p-checkbox>
      <label for="enabledCheckbox" class="checkbox-label">Set is enabled</label>
    </div>

    <!-- Selected Items Info -->
    <div class="info-section" *ngIf="config.data?.selectedItems?.length > 0">
      <div class="info-card">
        <i class="pi pi-info-circle"></i>
        <span>{{ config.data.selectedItems.length }} selected items will be added to this set</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="dialog-actions">
      <button pButton 
              type="button"
              label="Cancel" 
              class="p-button-text" 
              (click)="cancel()"
              [disabled]="loading">
      </button>
      <button pButton 
              type="submit"
              label="Create Set" 
              class="p-button-primary"
              [disabled]="newSetForm.invalid || loading"
              [loading]="loading">
      </button>
    </div>
  </form>
</div>